import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { resetPassword } from "../services/userService.js";

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";

  const [newPassword,     setNewPassword]     = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPwd,         setShowPwd]         = useState(false);
  const [loading,         setLoading]         = useState(false);
  const [success,         setSuccess]         = useState(false);
  const [error,           setError]           = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!token) {
      setError("Lien invalide ou incomplet. Redemandez un email de réinitialisation.");
      return;
    }
    if (newPassword.length < 8) {
      setError("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }

    setLoading(true);
    try {
      await resetPassword(token, newPassword);
      setSuccess(true);
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      setError(err.message || "Ce lien est invalide ou a expiré. Redemandez un nouvel email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:"var(--navy-mid)", padding:24 }}>
      <div style={{ width:"100%", maxWidth:400 }}>

        <div style={{ textAlign:"center", marginBottom:32 }}>
          <img src="/logo-cpuc.png" alt="CPUc" style={{ height:48, objectFit:"contain" }} />
        </div>

        <div style={{ background:"var(--card-bg)", borderRadius:16, padding:"32px 28px", boxShadow:"0 4px 24px rgba(0,0,0,.08)" }}>

          {!success ? (
            <>
              <div style={{ width:56, height:56, borderRadius:"50%", background:"rgba(230,51,41,.08)", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 20px" }}>
                <i className="bi bi-shield-lock-fill" style={{ fontSize:22, color:"#E63329" }} />
              </div>

              <h2 style={{ fontFamily:"Syne,sans-serif", fontSize:22, fontWeight:800, color:"var(--text-1)", textAlign:"center", marginBottom:8 }}>
                Nouveau mot de passe
              </h2>
              <p style={{ fontSize:13, color:"var(--text-2)", textAlign:"center", marginBottom:28, lineHeight:1.6 }}>
                Choisissez un nouveau mot de passe pour votre compte.
              </p>

              {!token && (
                <div style={{ background:"rgba(220,38,38,.08)", border:"1px solid rgba(220,38,38,.2)", borderRadius:10, padding:"10px 14px", marginBottom:20, fontSize:13, color:"#DC2626", display:"flex", alignItems:"center", gap:8 }}>
                  <i className="bi bi-exclamation-triangle-fill" />
                  Aucun jeton de réinitialisation trouvé dans le lien.
                </div>
              )}

              {error && (
                <div style={{ background:"rgba(220,38,38,.08)", border:"1px solid rgba(220,38,38,.2)", borderRadius:10, padding:"10px 14px", marginBottom:20, fontSize:13, color:"#DC2626", display:"flex", alignItems:"center", gap:8 }}>
                  <i className="bi bi-exclamation-triangle-fill" />
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="itm-label">Nouveau mot de passe</label>
                  <div className="input-group-itm" style={{ position:"relative" }}>
                    <i className="bi bi-lock input-icon" />
                    <input
                      type={showPwd ? "text" : "password"} className="itm-input"
                      value={newPassword} onChange={e => setNewPassword(e.target.value)}
                      placeholder="Minimum 8 caractères" required style={{ paddingRight:42 }}
                      autoComplete="new-password"
                    />
                    <button type="button" onClick={() => setShowPwd(v => !v)}
                      style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", color:"var(--text-3)", fontSize:15 }}>
                      <i className={`bi bi-eye${showPwd ? "-slash" : ""}`} />
                    </button>
                  </div>
                </div>

                <div className="form-group" style={{ marginBottom:20 }}>
                  <label className="itm-label">Confirmer le mot de passe</label>
                  <div className="input-group-itm">
                    <i className="bi bi-lock input-icon" />
                    <input
                      type={showPwd ? "text" : "password"} className="itm-input"
                      value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)}
                      placeholder="••••••••" required
                      autoComplete="new-password"
                    />
                  </div>
                </div>

                <button type="submit" disabled={loading || !token}
                  style={{
                    width:"100%", padding:"12px 16px", border:"none", borderRadius:10,
                    fontSize:14, fontWeight:600, cursor: (loading || !token) ? "not-allowed" : "pointer",
                    display:"flex", alignItems:"center", justifyContent:"center", gap:8,
                    background: (loading || !token) ? "var(--navy-soft)" : "#E63329",
                    color: (loading || !token) ? "var(--text-3)" : "#fff",
                  }}>
                  {loading
                    ? <><i className="bi bi-arrow-repeat spin" /> Réinitialisation…</>
                    : <><i className="bi bi-check-lg" /> Réinitialiser le mot de passe</>
                  }
                </button>
              </form>
            </>
          ) : (
            <>
              <div style={{ width:56, height:56, borderRadius:"50%", background:"rgba(34,197,94,.1)", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 20px" }}>
                <i className="bi bi-check-circle-fill" style={{ fontSize:22, color:"#22C55E" }} />
              </div>
              <h2 style={{ fontFamily:"Syne,sans-serif", fontSize:20, fontWeight:800, color:"var(--text-1)", textAlign:"center", marginBottom:8 }}>
                Mot de passe mis à jour
              </h2>
              <p style={{ fontSize:13, color:"var(--text-2)", textAlign:"center", lineHeight:1.6 }}>
                Redirection vers la page de connexion…
              </p>
            </>
          )}

        </div>

        <p style={{ textAlign:"center", fontSize:11, color:"var(--text-3)", marginTop:20 }}>
          © {new Date().getFullYear()} CPUc Solutions Technologiques
        </p>
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        .spin { animation: spin .7s linear infinite; display: inline-block; }
      `}</style>
    </div>
  );
}
